import { Divider } from '@mui/material';
import React from 'react';
import { Colors } from '../../utils/theme';

type IPropType = {
  open: boolean;
};

const NavDivider: React.FunctionComponent<IPropType> = ({ open }: IPropType) => {
  return (
    <Divider
      sx={{
        backgroundColor: Colors.third,
        marginLeft: open ? '14px' : '-2px',
        marginRight: open ? 0 : '-2px'
      }}
    />
  );
};

export default NavDivider;
